import Mapping from "../mapping";

import ExEpubCFI from "./epubcfi";
import { nodeBounds } from "../utils/core";

class ExMapping extends Mapping{
	constructor(layout, direction, axis, dev=false) {
		super(layout, direction, axis, dev);
	}

    /**
	 * Find CFI pairs for a page
	 * @param {Contents} contents Contents from view
	 * @param {string} cfiBase string of the base for a cfi
	 * @param {number} start position to start at
	 * @param {number} end position to end at
	 */
	page(contents, cfiBase, start, end) {
		var root = contents && contents.document ? contents.document.body : false;
		var result;

		if (!root) {
			return;
		}

		result = this.rangePairToCfiPair(cfiBase, {
			start: this.findStart(root, start, end),
			end: this.findEnd(root, start, end)
		});

		if (this._dev === true) {
			let doc = contents.document;
			let startRange = new ExEpubCFI(result.start).toRange(doc);
			let endRange = new ExEpubCFI(result.end).toRange(doc);

			let selection = doc.defaultView.getSelection();
			let r = doc.createRange();
			selection.removeAllRanges();
			r.setStart(startRange.startContainer, startRange.startOffset);
			r.setEnd(endRange.endContainer, endRange.endOffset);
			selection.addRange(r);
		}

		return result;
	}

	selection(contents, cfiBase, startPo, endPo){
		var root = contents && contents.document ? contents.document.body : false;
		var result;

		if (!root) {
			return;
		}

		let rectangle = {
			x: Math.min(startPo.clientX, endPo.clientX),
			y: Math.min(startPo.clientY, endPo.clientY),
			width: Math.max(startPo.clientX, endPo.clientX) - Math.min(startPo.clientX, endPo.clientX),
			height: Math.max(startPo.clientY, endPo.clientY) - Math.min(startPo.clientY, endPo.clientY)
		};

		rectangle.top = rectangle.y;
		rectangle.bottom = rectangle.y + rectangle.height;
		rectangle.left = rectangle.x;
		rectangle.right = rectangle.x + rectangle.width;

		rectangle.start = {
			x:startPo.clientX,
			y:startPo.clientY
		};
		rectangle.end = {
			x:endPo.clientX,
			y:endPo.clientY
		};

		let doc = contents.document;
		let selection = doc.defaultView.getSelection();
		let selectionRange = this.findSelectionBetween(root, rectangle);
		if(selectionRange){
			selection.removeAllRanges();
			selection.addRange(selectionRange);
		}
		
		return selection;

	}

	findSelectionBetween(root, rectangle){
		var stack = [root];
		var containEl = [];
		var $el;
		var found;
		var $prev = root;

		while (stack.length) {

			$el = stack.shift();

			found = this.walk($el, (node) => {
				var elPos;

				elPos = nodeBounds(node);

				if(this.isCollide(rectangle,elPos)) {
					if(node.nodeType == Node.TEXT_NODE){
						containEl.push(node);
					}else{
						$prev = node;
						stack.push(node);
					}
				}else{
					if(containEl.length){
						//找到大致範圍及終止
						if(this.direction === "ltr"){
							if(elPos.left > rectangle.right){
								return containEl;
							}else{
								$prev = node;
								stack.push(node);
							}
						}else{
							if(elPos.right < rectangle.left){
								return containEl;
							}else{
								$prev = node;
								stack.push(node);
							}
						}
					}else{
						$prev = node;
						stack.push(node);
					}
				}
			});

			if(found) {
				return this.findSelectionRange(found, rectangle);
			}
		}

		if(containEl.length && !found){
			found = containEl;
			return this.findSelectionRange(found, rectangle);
		}
	}

	findSelectionRange(nodeList, rectangle){
		var selectionRange = {
			start : null,
			end : null
		};
		var j, i, node, ranges, range, pos, startCollidePo, endCollidePo;

		var startRectangle = {}, endRectangle = {}, finsStartWay = "firstCollide", findEndWay = "firstCollide";
		if(this.horizontal){
			if(Math.max(rectangle.start.y, rectangle.end.y) - Math.min(rectangle.start.y, rectangle.end.y) < 10){
				if(this.direction === "ltr"){
					startRectangle = rectangle[(rectangle.start.x == Math.min(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
					endRectangle = rectangle[(rectangle.start.x !== Math.min(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
				}else{
					startRectangle = rectangle[(rectangle.start.x == Math.max(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
					endRectangle = rectangle[(rectangle.start.x !== Math.max(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
				}
			}else{
				startRectangle = rectangle[(rectangle.start.y == Math.min(rectangle.start.y, rectangle.end.y)) ? "start" : "end"];
				endRectangle = rectangle[(rectangle.start.y !== Math.min(rectangle.start.y, rectangle.end.y)) ? "start" : "end"];
				if(this.direction === "ltr"){
					if(endRectangle.x < startRectangle.x){
						finsStartWay = "afterCollide";
						findEndWay = "afterCollide";
					}
				}else{
					if(endRectangle.x > startRectangle.x){
						finsStartWay = "afterCollide";
						findEndWay = "afterCollide";
					}
				}
			}
		}else{
			if(Math.max(rectangle.start.x, rectangle.end.x) - Math.min(rectangle.start.x, rectangle.end.x) < 10){
				startRectangle = rectangle[(rectangle.start.y == Math.min(rectangle.start.y, rectangle.end.y)) ? "start" : "end"];
				endRectangle = rectangle[(rectangle.start.y !== Math.min(rectangle.start.y, rectangle.end.y)) ? "start" : "end"];
			}else{
				if(this.direction === "ltr"){
					startRectangle = rectangle[(rectangle.start.x == Math.min(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
					endRectangle = rectangle[(rectangle.start.x !== Math.min(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
				}else{
					startRectangle = rectangle[(rectangle.start.x == Math.max(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
					endRectangle = rectangle[(rectangle.start.x !== Math.max(rectangle.start.x, rectangle.end.x)) ? "start" : "end"];
				}
				if(endRectangle.y < startRectangle.y){
					finsStartWay = "afterCollide";
					findEndWay = "afterCollide";
				}
			}
		}

		//find start range
		for (j = 0; j < nodeList.length; j++) {
			if(!selectionRange.start){
				node = nodeList[j];
				ranges = this.splitTextNodeIntoRanges(node);
				if(finsStartWay == "firstCollide"){
					for (i = 0; i < ranges.length; i++) {
						range = ranges[i];
						pos = range.getBoundingClientRect();
						if(this.isCollide(rectangle,pos)) {
							selectionRange.start = range;
							break;
						}	
					}
				}else{
					startCollidePo = [];
					for (i = 0; i < ranges.length; i++) {
						range = ranges[i];
						pos = range.getBoundingClientRect();
						if(this.isCollide(rectangle,pos)) {
							startCollidePo.push(range);
						}else if(startCollidePo.length){
							selectionRange.start = startCollidePo[startCollidePo.length-1];
							break;
						}
					}
				}
			}else{
				break;
			}
		}

		//find end range
		for (j = nodeList.length - 1; j >= 0; j--) {
			if(!selectionRange.end){
				node = nodeList[j];
				ranges = this.splitTextNodeIntoRanges(node);
				if(finsStartWay == "firstCollide"){
					for (i = ranges.length - 1; i >= 0; i--) {
						range = ranges[i];
						pos = range.getBoundingClientRect();
						if(this.isCollide(rectangle,pos)) {
							selectionRange.end = range;
							break;
						}	
					}
				}else{
					endCollidePo = [];
					for (i = ranges.length - 1; i >= 0; i--) {
						range = ranges[i];
						pos = range.getBoundingClientRect();
						if(this.isCollide(rectangle,pos)) {
							endCollidePo.push(range);
						}else if(endCollidePo.length){
							selectionRange.end = endCollidePo[endCollidePo.length-1];
							break;
						}	
					}
				}
			}else{
				break;
			}	
		}

		if(selectionRange.start && selectionRange.end){
			range = new Range();
  			range.setStart(selectionRange.start.startContainer, selectionRange.start.startOffset);
  			range.setEnd(selectionRange.end.endContainer, selectionRange.end.endOffset);
			return range;
		}else{
			return false;
		}
	}

	isCollide(rect1,rect2) {
        var maxX,maxY,minX,minY

        maxX = rect1.x+rect1.width >= rect2.x+rect2.width ? rect1.x+rect1.width : rect2.x+rect2.width
        maxY = rect1.y+rect1.height >= rect2.y+rect2.height ? rect1.y+rect1.height : rect2.y+rect2.height
        minX = rect1.x <= rect2.x ? rect1.x : rect2.x
        minY = rect1.y <= rect2.y ? rect1.y : rect2.y

        if(maxX - minX <= rect1.width+rect2.width && maxY - minY <= rect1.height+rect2.height){
          return true
        }else{
          return false
        }
      }

    /**
	 * Turn a pair of ranges into a pair of CFIs
	 * @private
	 * @param {string} cfiBase base string for an EpubCFI
	 * @param {object} rangePair { start: Range, end: Range }
	 * @return {object} { start: "epubcfi(...)", end: "epubcfi(...)" }
	 */
	rangePairToCfiPair(cfiBase, rangePair){

		var startRange = rangePair.start;
		var endRange = rangePair.end;

		startRange.collapse(true);
		endRange.collapse(false);

		let startCfi = new ExEpubCFI(startRange, cfiBase).toString();
		let endCfi = new ExEpubCFI(endRange, cfiBase).toString();

		return {
			start: startCfi,
			end: endCfi
		};

	}

	/**
	 * Walk a node, preforming a function on each node it finds
	 * @private
	 * @param {Node} root Node to walkToNode
	 * @param {function} func walk function
	 * @return {*} returns the result of the walk function
	 */
	walk(root, func) {
		// IE11 has strange issue, if root is text node IE throws exception on
		// calling treeWalker.nextNode(), saying
		// Unexpected call to method or property access instead of returing null value
		if(root && root.nodeType === Node.TEXT_NODE) {
			return;
		}

		//將 文字節點, img, video, audio 等內容都納入範圍演算範疇
		var result = this.walkProcess(root, func);
		
		// safeFilter is required so that it can work in IE as filter is a function for IE
		// and for other browser filter is an object.
		/*var result;
		var filter = {
			acceptNode: function(node) {
				if (node.data.trim().length > 0) {
					return NodeFilter.FILTER_ACCEPT;
				} else {
					return NodeFilter.FILTER_REJECT;
				}
			}
		};
		var safeFilter = filter.acceptNode;
		safeFilter.acceptNode = filter.acceptNode;

		var treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, safeFilter, false);
		var node;
		var result;
		while ((node = treeWalker.nextNode())) {
			result = func(node);
			if(result) break;
		}*/

		return result;
	}

	walkProcess(root, func){
		let processResult;
		$(root).contents().each((index, node)=>{
			switch (node.nodeType){
				case 1 : let tagName = node.tagName;
						if(tagName === "IMG" || tagName === "IMAGE" || tagName === "VIDEO" || tagName === "AUDIO" || tagName === "BR"){
							processResult = func(node);
							if(processResult){
								return false;
							}
						}else{
							processResult = this.walkProcess(node, func);
							if(processResult){
								return false;
							}
						}
						 break;
				case 3: if (node.data.trim().length > 0) {
							processResult = func(node);
							if(processResult){
								return false;
							} 
						}break;
			}
		});
		return processResult;
	}

	/**
	 * Find Text Start Range
	 * @private
	 * @param {Node} root root node
	 * @param {number} start position to start at
	 * @param {number} end position to end at
	 * @return {Range}
	 */
	 findTextStartRange(node, start, end){
		var ranges = this.splitTextNodeIntoRanges(node);
		var range;
		var pos;
		var left, top, right;

		for (var i = 0; i < ranges.length; i++) {
			range = ranges[i];

			pos = range.getBoundingClientRect();

			if (this.horizontal && this.direction === "ltr") {
				left = pos.left;
				right = pos.right;
				if( left >= start ) {
					return range;
				}else if(left < start && right > start){
					return range;
				}

			} else if (this.horizontal && this.direction === "rtl") {
				left = pos.left;
				right = pos.right;
				if( right <= end ) {
					return range;
				}else if(right > end && left < end){
					return range;
				}

			} else {

				top = pos.top;
				if( top >= start ) {
					return range;
				}

			}

		}

		return ranges[0];
	}

	/**
	 * Find Text End Range
	 * @private
	 * @param {Node} root root node
	 * @param {number} start position to start at
	 * @param {number} end position to end at
	 * @return {Range}
	 */
	 findTextEndRange(node, start, end){
		var ranges = this.splitTextNodeIntoRanges(node);
		var range;
		var preRange;
		var pos;
		var left, right, top, bottom;

		//調整為回比對到的前一個range
		for (var i = 0; i < ranges.length; i++) {
			range = ranges[i];
			preRange = ( i == 0) ? ranges[i] : ranges[i-1];

			pos = range.getBoundingClientRect();

			if (this.horizontal && this.direction === "ltr") {

				left = pos.left;
				right = pos.right;

				if(right > end) {
					return preRange;
				}

			} else if (this.horizontal && this.direction === "rtl") {

				left = pos.left
				right = pos.right;

				if(left < start) {
					return preRange;
				}

			} else {

				top = pos.top;
				bottom = pos.bottom;

				if(top > end) {
					return preRange;
				} else if(bottom > end) {
					return preRange;
				}

			}

		}

		// Ends before limit
		return ranges[ranges.length-1];

	}

	/**
	 * Split up a text node into ranges for each word
	 * @private
	 * @param {Node} root root node
	 * @param {string} [_splitter] what to split on
	 * @return {Range[]}
	 */
	 splitTextNodeIntoRanges(node, _splitter){
		var ranges = [];
		var textContent = node.textContent || "";
		var text = textContent;
		var range;
		var doc = node.ownerDocument;
		var splitter = _splitter || " ";

		//加入中文分割方式
		if(node.nodeType != Node.TEXT_NODE) {
			range = doc.createRange();
			range.selectNodeContents(node);
			return [range];
		}else{
			let wordReg = /([^A-Za-z])/;
			let spaceSpItemArray = text.split(wordReg).filter((value)=>{
				return value !== "";
			});
			let totalTextLength = 0;
			$.each(spaceSpItemArray, (index, word)=>{
				let rangeStart = totalTextLength;
				totalTextLength += word.length;
				let rangeEnd = totalTextLength;
				range = doc.createRange();
				range.setStart(node, rangeStart);
				range.setEnd(node, rangeEnd);
				ranges.push(range);
			});
		}

		/*var pos = text.indexOf(splitter);

		if(pos === -1 || node.nodeType != Node.TEXT_NODE) {
			range = doc.createRange();
			range.selectNodeContents(node);
			return [range];
		}

		range = doc.createRange();
		range.setStart(node, 0);
		range.setEnd(node, pos);
		ranges.push(range);
		range = false;

		while ( pos != -1 ) {

			pos = text.indexOf(splitter, pos + 1);
			if(pos > 0) {

				if(range) {
					range.setEnd(node, pos);
					ranges.push(range);
				}

				range = doc.createRange();
				range.setStart(node, pos+1);
			}
		}

		if(range) {
			range.setEnd(node, text.length);
			ranges.push(range);
		}*/

		return ranges;
	}
}

export default ExMapping;